/// <reference path="../../../tools/typings/angularjs/angular.d.ts"/>

module DealerwareWebComponents {

    "use strict";

    export class LandingPageController {

        public static $inject : string[] = [
            '$rootScope'
        ];

        constructor (
            public $rootScope: ng.IScope
        ) {
        }

        public exportReportCsv (type: string, collectionListName: string) : void {

            if (type === 'all') {
                this.$rootScope.$broadcast(
                'paginationEvent' + collectionListName, { action: 'exportAllAsCSV' }
                );
            }
            else if (type === 'this') {
                this.$rootScope.$broadcast(
                'paginationEvent' + collectionListName, { action: 'exportAsCSV' }
                );
            }
        }
    }

    getDealerwareWebComponentsModule().controller('LandingPageController', LandingPageController);
}
